import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDash,
  faArrowRightLong,
  faListTree,
} from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'gatsby';
import { Text } from '../../../components/Text';

export const StyledSeries = styled.div`
  margin-top: ${rem(`24px`)};
  margin-bottom: ${rem(`24px`)};
  background-color: ${({ theme }) => theme.colors.blue_1_90};
  border-radius: ${rem(`8px`)};
  padding: ${rem(`16px`)} 0;

  .series-header {
    color: ${({ theme }) => theme.colors.gray_3};
  }
  .header {
    display: flex;
    align-items: center;
    margin-bottom: ${rem(`12px`)};
  }
  .header-icon {
    color: ${({ theme }) => theme.colors.purple_2};
    margin-right: ${rem(`12px`)};
  }
  .series {
    margin-left: ${rem(`40px`)};
    padding-right: ${rem(`8px`)};
  }
  .series__item {
    margin-bottom: ${rem(`6px`)};
  }
  .label-container {
    position: relative;
    display: flex;
    align-items: center;
  }
  .text-container {
    margin-bottom: ${rem(`12px`)};
  }
  .link {
    .title {
      color: ${({ theme }) => theme.colors.pink_1};
    }
    &__icon {
      margin-left: ${rem(`6px`)};
    }
    &:hover {
      .title {
        transition: color 200ms ease-in-out;
        color: ${({ theme }) => theme.colors.pink_2};
      }
    }
  }
  .icon {
    color: ${({ theme }) => theme.colors.pink_1};
    position: absolute;
    left: 0;
    top: ${rem(`5px`)};
  }
  .title {
    transition: color 200ms ease-in-out;
    margin-left: ${rem(`30px`)};
    color: ${({ theme }) => theme.colors.gray_3};
  }
  .highlight-title {
    color: ${({ theme }) => theme.colors.gray_4};
    transition: 200ms color ease-in-out;
  }
  .highlight-icon {
    color: ${({ theme }) => theme.colors.yellow_1};
    transition: 200ms color ease-in-out;
  }
`;

interface ISeriesItems {
  title: string;
  slug: string;
  seriesOrder: number;
  current: boolean;
}

interface ISeries {
  className?: string;
  items: ISeriesItems[];
}

export const Series = ({ className, items }: ISeries) => {
  return (
    <StyledSeries className={className}>
      <div className="header">
        <FontAwesomeIcon className="header-icon" size="2x" icon={faListTree} />
        <Text noRhythem type="title4" className="series-header">
          Articles in this series
        </Text>
      </div>
      <div className="series">
        {items.map(({ title, slug, current }) =>
          current ? (
            <Text
              type="body3"
              tag="div"
              color="gray_3"
              noRhythem
              className="text-container"
              key={`${title}`}
            >
              <div className="label-container">
                <FontAwesomeIcon
                  className="icon highlight-icon"
                  size="1x"
                  icon={faArrowRightLong}
                />
                <span className="title highlight-title">{title}</span>
              </div>
            </Text>
          ) : (
            <Link
              to={`/blog/${slug}`}
              title={title}
              className="series__item"
              key={`${title}`}
            >
              <Text
                type="body3"
                tag="div"
                color="gray_3"
                className="text-container link"
                noRhythem
              >
                <div className="label-container">
                  <FontAwesomeIcon className="icon" size="1x" icon={faDash} />
                  <span className="title">{title}</span>
                </div>
              </Text>
            </Link>
          ),
        )}
      </div>
    </StyledSeries>
  );
};
